// extracted by mini-css-extract-plugin
module.exports = {"commitments-list":"commitments-list___3k29D"};